export function Box({
  children,
  title,
  actionComponent,
}: {
  children: React.ReactNode
  title?: string
  actionComponent?: React.ReactNode
}) {
  return (
    <div className="bg-white relative rounded-lg border-[1.5px] border-gray-300 p-6 h-fit">
      <div className="flex flex-col gap-8">
        {title && <h3 className="text-2xl">{title}</h3>}
        {children}
      </div>
      {actionComponent && (
        <div className="absolute top-6 right-6">{actionComponent}</div>
      )}
    </div>
  )
}
